import { gql } from "@apollo/client";

import { adminStatusFragment } from "src/graphql/anti-fraud/fragments/AdminStatusFragment";
import { elementFragment } from "src/graphql/anti-fraud/fragments/ElementFragment";
import { propertyValueFragment } from "src/graphql/anti-fraud/fragments/PropertyValueFragment";

export const caseSummaryFragment = gql`
  fragment CaseSummaryFragment on Case {
    id
    lastScore
    typeCode
    properties {
      ...PropertyValueFragment
    }
    elements {
      ...ElementFragment
    }
    adminStatus {
      ...AdminStatus
    }

    snapshotCreation
  }

  ${elementFragment}
  ${propertyValueFragment}
  ${adminStatusFragment}
`;
